(() => {
  if (window.hvNavigationLoaded) return;
  window.hvNavigationLoaded = true;
  const media = window.matchMedia('(min-width:901px)');
  const hover = window.matchMedia('(hover:hover) and (pointer:fine)');
  function initialise(scope = document) {
    scope.querySelectorAll('.hv-head-menu').forEach(menu => {
      if (menu.dataset.ready) return;
      menu.dataset.ready = 'true';
      menu.open = media.matches;
      const groups = [...menu.querySelectorAll('.hv-head-group')];
      groups.forEach(group => {
        let closeTimer;
        let openedByHover = false;
        group.querySelector('summary').addEventListener('click', event => {
          if (openedByHover && media.matches && hover.matches && event.detail > 0) {
            event.preventDefault();
            group.open = true;
          }
        });
        group.addEventListener('pointerenter', event => {
          if (!media.matches || !hover.matches || event.pointerType === 'touch') return;
          clearTimeout(closeTimer);
          groups.forEach(other => { if (other !== group) other.open = false; });
          group.open = true;
          openedByHover = true;
        });
        group.addEventListener('pointerleave', event => {
          if (!media.matches || !hover.matches || event.pointerType === 'touch') return;
          clearTimeout(closeTimer);
          closeTimer = setTimeout(() => {
            if (!group.contains(document.activeElement)) group.open = false;
            openedByHover = false;
          }, 180);
        });
        group.addEventListener('toggle', () => {
          if (group.open) groups.forEach(other => { if (other !== group) other.open = false; });
        });
      });
      menu.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const group = event.target.closest('.hv-head-group');
        if (group && group.open) {
          group.open = false;
          group.querySelector('summary').focus();
        } else if (!media.matches) {
          menu.open = false;
          menu.querySelector('summary').focus();
        }
      });
    });
  }
  document.addEventListener('click', event => {
    document.querySelectorAll('.hv-head-group[open]').forEach(group => {
      if (!group.contains(event.target)) group.open = false;
    });
  });
  media.addEventListener('change', () => {
    document.querySelectorAll('.hv-head-menu').forEach(menu => { menu.open = media.matches; });
  });
  document.addEventListener('shopify:section:load', event => initialise(event.target));
  initialise();
})();

